<template>
  <div class="app">
    <Snackbar :snackbar="snackbar" :text="text" @change="snackbar = $event" />
    <v-sheet v-show="showSkeleton" class="pa-3">
      <v-row>
        <v-col v-for="item in 3" :key="item">
          <v-skeleton-loader class="mx-auto" type="list-item" />
        </v-col>
      </v-row>
      <v-row>
        <v-col v-for="item in 2" :key="item">
          <v-skeleton-loader class="mx-auto" type="image" height="220" />
        </v-col>
      </v-row>
    </v-sheet>
    <v-form ref="form" v-show="!showSkeleton">
      <v-row>
        <v-col cols="4">
          <v-text-field
            dense
            v-model="form.numero"
            :error-messages="numeroErrors"
            :counter="10"
            :disabled="desativado"
            type="number"
            label="Número"
            outlined
            @input="$v.form.numero.$touch()"
            @blur="$v.form.numero.$touch()"
          />
        </v-col>
        <v-col cols="4">
          <v-text-field
            dense
            v-model="form.usuario"
            :error-messages="usuarioErrors"
            label="Nome"
            :counter="30"
            outlined
            @input="
              $v.form.usuario.$touch()
              form.usuario = $event.trim()
            "
            @blur="$v.form.usuario.$touch()"
          />
        </v-col>
        <v-col cols="4">
          <v-select
            dense
            v-model="form.tronco"
            :error-messages="troncoErrors"
            :items="troncos"
            outlined
            label="Troncos"
            @input="$v.form.tronco.$touch()"
            @blur="$v.form.tronco.$touch()"
          />
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="6">
          <DraggAndDrop
            dragname="Rotas"
            :valoresDisponiveisComboBox="rotasGeralDisponiveis"
            @dragUpdate="updateRotasGeral($event)"
            :opcoesSelecionadas="rotasGeralSelecionadas"
          />
        </v-col>
        <v-col cols="6">
          <DraggAndDrop
            dragname="Rotas de Transferência"
            :valoresDisponiveisComboBox="rotasTransferenciasDisponiveis"
            @dragUpdate="updateRotasTransferencia($event)"
            :opcoesSelecionadas="rotasTransferenciasSelecionadas"
          />
        </v-col>
      </v-row>
      <v-divider dark vertical />
      <v-divider dark />
      <v-divider dark vertical />
      <FixedButtons @salvar="salvar" @cancelar="cancelar" :pararLoader="pararLoader" />
    </v-form>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { validationMixin } from 'vuelidate'

import Snackbar from '@/componentes/Snackbar'
import FixedButtons from '@/componentes/FixedButtons'
import { registerVuexModule, formatarRota } from '@/utils/vuexUtils'
import { ordenar } from '@/utils/ordenarArrayByText'

import ramaisStore from '../_store'
import DraggAndDrop from '../_components/DraggAndDrop'
import RamaisHttpService from '../_services/RamaisHttpService'
import { validateData, validateComputed } from '../_validates/validatesVirtual'

export default {
  name: 'AbaRamalVirtual',
  props: {
    edicao: String,
    _id: String,
  },
  components: { DraggAndDrop, Snackbar, FixedButtons },
  mixins: [validationMixin],
  data: () => ({
    form: {
      numero: '',
      usuario: '',
      tipo: 'VIRTUAL',
      tronco: '',
      rota: {},
      rotaTransferencia: {},
    },
    rotasGeralDisponiveis: [],
    rotasGeralSelecionadas: [],
    rotasTransferenciasDisponiveis: [],
    rotasTransferenciasSelecionadas: [],
    troncos: [],
    item: -1,
    text: '',
    snackbar: false,
    desativado: false,
    showSkeleton: true,
    pararLoader: {
      parar: false,
    },
  }),

  validations: {
    ...validateData,
  },

  computed: {
    ...mapGetters('abaRamalVirtualModulePABXStore', [
      'getTroncosDisponveis',
      'getRotasDisponiveis',
      'getRamalSelecionado',
    ]),
    ...validateComputed,
  },

  async created() {
    registerVuexModule(this.$store, 'abaRamalVirtualModulePABXStore', ramaisStore)

    await Promise.all([this.listarTroncos(), this.listarRotas()])

    this.getTroncosDisponveis.forEach(tronco => {
      if (tronco.interno) {
        this.troncos.push({ text: tronco.description, value: tronco._id })
      }
    })

    this.rotasTransferenciasDisponiveis = [...this.getRotasDisponiveis]
    this.rotasGeralDisponiveis = [...this.getRotasDisponiveis]

    if (this.edicao === 'true') {
      this.desativado = true
      this.form = this.getRamalSelecionado
      this.troncos.find(tronco => tronco._id == this.getRamalSelecionado.tronco)

      const arrayrotasSelecionadas = Object.values(this.getRamalSelecionado.rota)
      const arrayrotasTransferenciaSelecionadas = Object.values(this.getRamalSelecionado.rotaTransferencia)

      arrayrotasSelecionadas.forEach(rotasSelecionadas => {
        const indexRotaGeral = this.rotasGeralDisponiveis.findIndex(rotaGeral => rotaGeral._id === rotasSelecionadas)

        if (indexRotaGeral !== -1) {
          this.rotasGeralSelecionadas.push(this.rotasGeralDisponiveis[indexRotaGeral])
        }
      })

      arrayrotasTransferenciaSelecionadas.forEach(rotasSelecionadas => {
        const indexRotaTransferencia = this.rotasTransferenciasDisponiveis.findIndex(
          rotaTransferencia => rotaTransferencia._id === rotasSelecionadas
        )

        if (indexRotaTransferencia !== -1) {
          this.rotasTransferenciasSelecionadas.push(this.rotasTransferenciasDisponiveis[indexRotaTransferencia])
        }
      })
    } else {
      this.rotasTransferenciasSelecionadas = this.getRotasDisponiveis.filter(rota => rota.default)
      this.rotasGeralSelecionadas = this.getRotasDisponiveis.filter(rota => rota.default)
    }

    ordenar(this.rotasTransferenciasDisponiveis)
    ordenar(this.rotasGeralDisponiveis)
    this.showSkeleton = false
  },

  methods: {
    ...mapActions('abaRamalVirtualModulePABXStore', ['listarTroncos', 'listarRotas']),
    updateRotasGeral(event) {
      this.form.rota = formatarRota(event)
    },
    updateRotasTransferencia(event) {
      this.form.rotaTransferencia = formatarRota(event)
    },
    async salvar() {
      this.pararLoader.parar = false

      if (!this.form.rota['1']) {
        this.text = 'Nenhuma rota selecionada.'
        this.snackbar = true
        this.pararLoader.parar = true
        return
      }
      if (!this.form.rotaTransferencia['1']) {
        this.text = 'Nenhuma rota de transferência selecionada.'
        this.snackbar = true
        this.pararLoader.parar = true
        return
      }

      this.$v.$touch()
      if (this.$v.$error) {
        this.$vuetify.goTo(1, { duration: 1000, easing: 'easeOutCubic' })
        this.pararLoader.parar = true
        return
      }

      try {
        if (this.edicao === 'true') {
          delete this.form.numero
          await RamaisHttpService.putRamal(this.form)
        } else {
          await RamaisHttpService.postRamal(this.form)
        }
        this.$router.push({ name: 'Ramais' })
      } catch (error) {
        let key = Object.keys(error.response.data)
        this.text = error.response.data[key[0]]
        this.snackbar = true
        this.pararLoader.parar = true
      }
    },
    cancelar() {
      this.$router.push({ name: 'Ramais' })
    },
  },
}
</script>

<style scoped>
.app {
  background-color: var(--v-background-base);
}
</style>
